const API_LABELS = new Map([
  ['checkInitData','init'], ['token','token'], ['routes','routes'], ['labels','labels'], ['info','info'], ['currency','currency'],
  ['redirects','redirects'], ['menus','menus'], ['rotators','rotators'], ['cmsstaticcontent/pages','cms'],
  ['cmsstaticcontent/resolve','cms_resolve'], ['cmsstaticcontent/catalog-index','cms_index'], ['staticcontent/pages','static'],
  ['catalog/products','products'], ['catalog/categories','categories'], ['catalog/manufacturers','manufacturers'], ['catalog/lists','lists'],
]);
const API_GROUPS = new Set(API_LABELS.values());
export const cmsDiagnosticsEnabled = config => config?.cmsDiagnostics === true || config?.cmsDiagnostics === 'true';
export function createSsrTrace(started = performance.now()) { return {started, calls:[], dropped:0}; }
export function ssrApiLabel(url) {
  const path = String(url || '').split(/[?#]/)[0].replace(/\/+$/,'');
  if(/^\/hapi\/(?:latest|v[0-9]+)\/cms\/redirect$/.test(path))return 'redirects';
  const internal = path.replace(/^\/api\/nuxtapi\//,'');
  return API_LABELS.get(internal) || 'other';
}
export function traceSsrApi(trace, url, run, clock = () => performance.now()) {
  if (trace.calls.length >= 64) { trace.dropped++; return run(); }
  const call = {label:ssrApiLabel(url), start:clock()};
  trace.calls.push(call);
  const end = (failed, value) => {
    call.end = clock(); call.failed = failed;
    const status = Number(value?.statusCode ?? value?.status ?? value?.response?.status);
    if (failed && Number.isInteger(status) && status >= 400 && status <= 599) call.status = status;
  };
  try {
    return Promise.resolve(run()).then(value => {end(Number(value?.statusCode) >= 400, value); return value;},error => {end(true, error); throw error;});
  } catch (error) { end(true, error); throw error; }
}
export function ssrApiFailureHeader(trace) {
  const counts = new Map();
  for (const call of trace?.calls || []) {
    if (!call.failed) continue;
    const label = API_GROUPS.has(call.label) ? call.label : 'other';
    const status = Number.isInteger(call.status) && call.status >= 400 && call.status <= 599 ? call.status : 'ERROR';
    const key = `${label}:${status}`;
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  return [...counts].map(([key, count]) => `${key}=${count}`).join(', ');
}
export function spanUnion(calls, start, end) {
  const spans = calls.filter(c => Number.isFinite(c.end)).map(c => [Math.max(start,c.start),Math.min(end,c.end)]).filter(([a,b]) => b > a).sort((a,b) => a[0]-b[0]);
  let total=0,last=-Infinity;
  for(const [a,b] of spans) { total+=Math.max(0,b-Math.max(a,last)); last=Math.max(last,b); }
  return total;
}
export function ssrMetrics(trace) {
  if (!trace) return {};
  const out={};
  const span=(name,a,b) => {if(Number.isFinite(a)&&Number.isFinite(b)&&b>=a)out[name]=b-a;};
  span('ssr_queue',trace.queueStart,trace.admitted);
  if(!Number.isFinite(trace.pluginStart))return out;
  span('ssr_setup',trace.started,trace.pluginStart);
  if(out.ssr_setup!==undefined)out.ssr_setup=Math.max(0,out.ssr_setup-(out.ssr_queue||0));
  span('ssr_init',trace.pluginStart,trace.appCreated);
  span('ssr_render',trace.appCreated,trace.appRendered);
  span('ssr_finalize',trace.appRendered,trace.htmlReady);
  span('ssr_html',trace.htmlReady,trace.responseReady);
  span('ssr_tail',trace.responseReady,trace.beforeResponse);
  for(const [phase,a,b] of [['init',trace.pluginStart,trace.appCreated],['render',trace.appCreated,trace.appRendered]]) {
    if(!Number.isFinite(a)||!Number.isFinite(b))continue;
    out['ssr_'+phase+'_api']=spanUnion(trace.calls,a,b);
    out['ssr_'+phase+'_other']=Math.max(0,b-a-out['ssr_'+phase+'_api']);
  }
  for(const call of trace.calls)if(Number.isFinite(call.end))out['ssr_api_'+call.label]=Math.max(out['ssr_api_'+call.label]||0,call.end-call.start);
  return out;
}
export function ssrTimingHeader(trace) {
  const counts=new Map();
  for(const call of trace?.calls || [])counts.set(call.label,(counts.get(call.label)||0)+1);
  return Object.entries(ssrMetrics(trace)).filter(([,value])=>Number.isFinite(value)).map(([name,value])=>`${name};dur=${value.toFixed(1)}${name.startsWith('ssr_api_') ? `;desc="${counts.get(name.slice(8)) || 0} calls"` : ''}`).join(', ');
}
export function withoutCmsTimings(value) {
  const parts=[];let start=0,quoted=false,escaped=false;
  for(let i=0;i<value.length;i++) {
    const c=value[i];
    if(escaped){escaped=false;continue;}
    if(c==='\\'&&quoted){escaped=true;continue;}
    if(c==='"')quoted=!quoted;
    if(c===','&&!quoted){parts.push(value.slice(start,i));start=i+1;}
  }
  parts.push(value.slice(start));
  return parts.filter(part=>!/^\s*(?:cms|ssr)_/.test(part)).map(part=>part.trim()).filter(Boolean).join(', ');
}
